<script>
  import "vite/dynamic-import-polyfill";

  import { Footer } from "./shared";
  import MultiUsersLicenseForm from "./marketing/MultiUserLicenseForm.svelte";
  import dallas_src from "./marketing/images/dallas.svg";
  import magnolia_src from "./marketing/images/magnolia.svg";
  import conroe_src from "./marketing/images/conroe.svg";
  import austin_src from "./marketing/images/austin.svg";
  import boces_src from "./marketing/images/boces.svg";
  import esc20_src from "./marketing/images/esc20.svg";
  import support_src from "./marketing/images/support.svg";
  import collaboration_src from "./marketing/images/collaboration.svg";
  import dashboard_src from "./marketing/images/dashboard.svg";
  import po_src from "./marketing/images/po.svg";
  import lms_src from "./marketing/images/lms.svg";
  import translation_src from "./marketing/images/translation.svg";

  function lookingForSupport(event) {
    const beacon = window.Beacon;
    if (beacon) {
      try {
        beacon("open");
        event.stopPropagation();
        event.preventDefault();
      } catch (e) {
        //do nothing
      }
    }
  }

  export let user;
</script>

<div class="relative h-full mx-auto container-1200">
  <div class="flex flex-col items-center justify-between mt-5 mb-10 sm:mb-16 lg:my-20 lg:flex-row lg:items-start">
    <div class="w-full" style="max-width: 36.2rem;">
      <h1 class="font-bold text-brand-gray header">Smore for Teams. Work better together.</h1>
      <div class="mt-5 text-nxgray-500 text-20">
        A Smore Team account is for multiple people. <br />Need one account?
        <a href="/educators?s=demo_page" class="font-medium text-teal-600">Click here.</a>
      </div>

      <div class="mt-8 text-20">
        <div class="flex items-start justify-start">
          <svg class="w-5 h-5 mt-1 mr-3" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.5" cy="10.5" r="10.5" fill="#B5F2E7" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.36292 11.5849c.05996.3049.18313.5181.4627.7006l3.35481 2.19c.46595.3042 1.16977.1658 1.56397-.3076l4.2081-6.68582c.316-.45798.1811-1.14391-.2998-1.5243-.466-.30417-1.1697-.16573-1.4708.36846L9.52767 12.1115l-2.50112-1.5663c-.48094-.3804-1.18472-.2419-1.50075.216-.18962.2748-.22285.5188-.16288.8237z"
              fill="#505060" />
          </svg>
          Get an overview of the benefits of a Team account
        </div>
        <div class="flex items-start justify-start mt-5">
          <svg class="w-5 h-5 mt-1 mr-3" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.5" cy="10.5" r="10.5" fill="#B5F2E7" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.36292 11.5849c.05996.3049.18313.5181.4627.7006l3.35481 2.19c.46595.3042 1.16977.1658 1.56397-.3076l4.2081-6.68582c.316-.45798.1811-1.14391-.2998-1.5243-.466-.30417-1.1697-.16573-1.4708.36846L9.52767 12.1115l-2.50112-1.5663c-.48094-.3804-1.18472-.2419-1.50075.216-.18962.2748-.22285.5188-.16288.8237z"
              fill="#505060" />
          </svg>
          Learn about special features like Collaboration, Translation and MNS Export
        </div>
        <div class="flex items-start justify-start mt-5">
          <svg class="w-5 h-5 mt-1 mr-3" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.5" cy="10.5" r="10.5" fill="#B5F2E7" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.36292 11.5849c.05996.3049.18313.5181.4627.7006l3.35481 2.19c.46595.3042 1.16977.1658 1.56397-.3076l4.2081-6.68582c.316-.45798.1811-1.14391-.2998-1.5243-.466-.30417-1.1697-.16573-1.4708.36846L9.52767 12.1115l-2.50112-1.5663c-.48094-.3804-1.18472-.2419-1.50075.216-.18962.2748-.22285.5188-.16288.8237z"
              fill="#505060" />
          </svg>
          Get pricing info | PO option for Team account only
        </div>
      </div>

      <div class="flex items-center justify-start w-full mt-8 mb-2 text-nxgray-500 text-21">
        Looking for support?
        <a class="ml-2 link" target="_blank" alt="click to get help" href="https://help.smore.com" on:click={lookingForSupport}
          >Click here</a>
      </div>
      <div class="hidden grid-cols-3 gap-4 mt-16 sm:grid place-items-start">
        <div
          class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
          style="background-image: url({dallas_src});"
          role="img"
          aria-label="Dallas ISD Logo" />
        <div
          class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
          style="background-image: url({magnolia_src});"
          role="img"
          aria-label="Magnolia ISD Logo" />
        <div
          class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
          style="background-image: url({conroe_src});"
          role="img"
          aria-label="Conroe ISD Logo" />
        <div
          class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
          style="background-image: url({austin_src});"
          role="img"
          aria-label="Austin ISD Logo" />
        <div
          class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
          style="background-image: url({boces_src});"
          role="img"
          aria-label="BOCES Logo" />
        <div
          class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
          style="background-image: url({esc20_src});"
          role="img"
          aria-label="ESC 20 Logo" />
      </div>
      <div class="hidden mt-3 text-center sm:block text-15 lg:text-left text-nxgray-400">
        Trusted by more than
        <span class="font-bold text-orange-600">1 million educators in 10,000+</span>
        schools and discricts.
      </div>
    </div>
    <div class="w-screen mt-8 overflow-hidden bg-white border shadow border-black-10 sm:rounded-md sm:w-full sm:max-w-xl lg:ml-4 lg:mt-0">
      <MultiUsersLicenseForm {user} />
    </div>
    <div class="grid w-full grid-cols-2 gap-4 mt-4 place-items-start sm:hidden">
      <div
        class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
        style="background-image: url({dallas_src});"
        role="img"
        aria-label="Dallas ISD Logo" />
      <div
        class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
        style="background-image: url({magnolia_src});"
        role="img"
        aria-label="Magnolia ISD Logo" />
      <div
        class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
        style="background-image: url({austin_src});"
        role="img"
        aria-label="Austin ISD Logo" />
      <div
        class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
        style="background-image: url({boces_src});"
        role="img"
        aria-label="BOCES Logo" />
      <div
        class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
        style="background-image: url({conroe_src});"
        role="img"
        aria-label="Conroe ISD Logo" />
      <div
        class="w-32 h-16 bg-center bg-no-repeat bg-contain sm:w-40"
        style="background-image: url({esc20_src});"
        role="img"
        aria-label="ESC 20 Logo" />
    </div>
    <div class="mt-3 text-left sm:hidden text-15">
      Trusted by more than
      <span class="font-bold text-orange-600">1 million educators in 10,000+</span>
      schools and discricts.
    </div>
  </div>
</div>

<div class="w-full pt-10 pb-32 -mb-20 bg-white sm:pt-20">
  <div class="relative h-full mx-auto container-1200">
    <div class="w-full mb-12 font-bold text-left multi-user-caption sm:text-center">
      Smore for Teams Features.<br /><span class="text-xl font-bold">Designed for schools, districts, departments and other teams.</span>
    </div>
    <div class="flex flex-col items-start justify-between sm:flex-row">
      <div class="max-w-xl sm:w-1/2">
        <div class="bg-center bg-no-repeat bg-contain w-9 h-9" style="background-image: url({support_src});" />
        <div class="mt-2 font-medium text-20">Getting started is easy</div>
        <div class="mt-2 text-16 text-brand-gray-70">
          Easy instructional videos and simple step-by-step documentation make it easy for everyone to get started.
        </div>
      </div>
      <div class="max-w-xl mt-8 sm:ml-10 sm:w-1/2 sm:mt-0">
        <div class="bg-center bg-no-repeat bg-contain w-9 h-9" style="background-image: url({collaboration_src});" />
        <div class="mt-2 font-medium text-20">Collaboration</div>
        <div class="mt-2 text-16 text-brand-gray-70 sm:max-w-lg md:max-w-xl">
          Empower multiple users to collaborate on a single newsletter, or on a folder of newsletters.
        </div>
      </div>
    </div>
    <div class="flex flex-col items-start justify-between mt-8 sm:flex-row">
      <div class="max-w-xl sm:w-1/2">
        <div class="bg-center bg-no-repeat bg-contain w-9 h-9" style="background-image: url({dashboard_src});" />
        <div class="mt-2 font-medium text-20">Management Dashboard & Analytics</div>
        <div class="mt-2 text-16 text-brand-gray-70">
          Oversee school and district communications. Get a broad view of overall stats, or zoom in on individual license member’s
          communications.
        </div>
      </div>
      <div class="max-w-xl mt-8 sm:ml-10 sm:w-1/2 sm:mt-0">
        <div class="bg-center bg-no-repeat bg-contain w-9 h-9" style="background-image: url({po_src});" />
        <div class="mt-2 font-medium text-20">Option to Submit PO</div>
        <div class="mt-2 text-16 text-brand-gray-70 sm:max-w-lg md:max-w-xl">
          The option to submit a PO is exclusively available to Team accounts. Or, pay via credit card, bank wire, or check.
        </div>
      </div>
    </div>
    <div class="flex flex-col items-start justify-between mt-8 sm:flex-row">
      <div class="max-w-xl sm:w-1/2">
        <div class="bg-center bg-no-repeat bg-contain w-9 h-9" style="background-image: url({lms_src});" />
        <div class="mt-2 font-medium text-20">Mass Notification System Integration</div>
        <div class="mt-2 text-16 text-brand-gray-70">
          Get access to our Remind and Blackboard integrations so you can manage all your school communications in one place.
        </div>
      </div>
      <div class="max-w-xl mt-8 sm:ml-10 sm:w-1/2 sm:mt-0">
        <div class="bg-center bg-no-repeat bg-contain w-9 h-9" style="background-image: url({translation_src});" />
        <div class="mt-2 font-medium text-20">Translation</div>
        <div class="mt-2 text-16 text-brand-gray-70 sm:max-w-lg md:max-w-xl">
          All users on a Team account can utilize our translation feature. Reach your audience easily, no matter what their home language.
        </div>
      </div>
    </div>
  </div>
</div>

<Footer />

<style>
  .multi-user-caption {
    font-size: 36px;
    line-height: 45px;
  }
  .header {
    font-size: 36px;
    line-height: 1.1;
  }
  /* Medium (md) */
  @media (min-width: 640px) {
    .multi-user-caption {
      font-size: 45px;
      line-height: 54px;
    }
    .header {
      font-size: 57px;
      line-height: 1;
    }
  }
</style>
